import { createContext, useCallback, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "pk_lang";

const DICT = {
  vi: {
    "nav.dashboard": "Tổng quan",
    "nav.tournaments": "Giải đấu",
    "nav.athletes": "Vận động viên",
    "nav.settings": "Cài đặt",
    "nav.users": "Quản lý người dùng",
    "nav.permissions": "Phân quyền",
    "nav.venues": "Địa điểm",
    "nav.emails": "Email",
    "nav.logout": "Đăng xuất",
    "nav.primary": "Chính",
    "topbar.welcome": "Chào mừng đến với PickLeague",
    "common.viewAll": "Xem tất cả",
    "common.requiresSuperAdmin": "Cần quyền Super Admin",
    "common.loading": "Đang tải...",
    "dashboard.title": "Admin Dashboard",
    "dashboard.subtitle": "Thống kê tổng quan hệ thống PickLeague",
    "dashboard.refresh": "Làm mới",
    "dashboard.lastUpdate": "Cập nhật",
    "dashboard.totalUsers": "Tổng người dùng",
    "dashboard.tournaments": "Giải đấu",
    "dashboard.matchesToday": "Trận đấu hôm nay",
    "dashboard.pendingRegs": "Đăng ký chờ duyệt",
    "dashboard.roleDistribution": "Phân bổ vai trò",
    "dashboard.featuredTournaments": "Giải đấu nổi bật",
    "dashboard.recentActivity": "Hoạt động gần đây",
    "dashboard.quickActions": "Thao tác nhanh",
    "dashboard.manageUsers": "Quản lý người dùng",
    "dashboard.manageTournaments": "Quản lý giải đấu",
    "dashboard.permissions": "Phân quyền",
    "dashboard.managePerms": "Quản lý quyền hạn",
    "dashboard.thisWeek": "tuần này",
    "dashboard.ongoing": "đang diễn ra",
    "dashboard.completed": "hoàn thành",
    "dashboard.needsAction": "Cần xử lý",
    "dashboard.participants": "người tham gia",
    "players.title": "Vận động viên",
    "players.subtitle": "Danh sách vận động viên cùng thông tin hồ sơ và thống kê cơ bản.",
    "players.search": "Tìm kiếm",
    "players.searchPlaceholder": "Tìm theo tên, username, email, sđt hoặc DUPR...",
    "players.searchBtn": "Tìm kiếm",
    "players.list": "Danh sách",
    "players.col.stt": "STT",
    "players.col.athlete": "Vận động viên",
    "players.col.contact": "Liên hệ",
    "players.col.profile": "Hồ sơ",
    "players.col.address": "Địa chỉ",
    "players.col.rating": "Trình độ",
    "players.col.played": "Thi đấu",
    "players.col.stats": "Thống kê",
    "players.col.status": "Trạng thái",
    "players.empty": "Không có dữ liệu",
    "players.totalSuffix": "vận động viên",
    "players.show": "Hiển thị",
    "players.prev": "Trước",
    "players.next": "Sau",
    "players.status.active": "Hoạt động",
    "players.status.inactive": "Ngưng",
    "players.tournaments": "giải",
    "players.regs": "đội",
    "players.approved": "duyệt",
    "players.detail.title": "Chi tiết vận động viên",
    "players.detail.regs": "Đăng ký",
    "players.detail.matches": "Trận đấu gần đây",
    "players.detail.noRegs": "Chưa có đăng ký nào",
    "players.filters.title": "Bộ lọc",
    "players.filters.status": "Trạng thái",
    "players.filters.statusAll": "Tất cả",
    "players.filters.statusActive": "Hoạt động",
    "players.filters.statusInactive": "Đã ngưng",
    "players.filters.province": "Tỉnh / Thành phố",
    "players.filters.provinceAll": "Tất cả tỉnh / thành",
    "players.filters.rating": "Trình độ",
    "players.filters.ratingMin": "Tối thiểu",
    "players.filters.ratingMax": "Tối đa",
    "players.filters.reset": "Đặt lại",
    "players.filters.apply": "Áp dụng",
    "players.filters.activeCount": "{n} bộ lọc đang áp dụng",
  },
  en: {
    "nav.dashboard": "Overview",
    "nav.tournaments": "Tournaments",
    "nav.athletes": "Athletes",
    "nav.settings": "Settings",
    "nav.users": "User Management",
    "nav.permissions": "Permissions",
    "nav.venues": "Venues",
    "nav.emails": "Emails",
    "nav.logout": "Sign out",
    "nav.primary": "Main",
    "topbar.welcome": "Welcome to PickLeague",
    "common.viewAll": "View all",
    "common.requiresSuperAdmin": "Requires Super Admin",
    "common.loading": "Loading...",
    "dashboard.title": "Admin Dashboard",
    "dashboard.subtitle": "PickLeague system overview",
    "dashboard.refresh": "Refresh",
    "dashboard.lastUpdate": "Updated",
    "dashboard.totalUsers": "Total users",
    "dashboard.tournaments": "Tournaments",
    "dashboard.matchesToday": "Matches today",
    "dashboard.pendingRegs": "Pending registrations",
    "dashboard.roleDistribution": "Role distribution",
    "dashboard.featuredTournaments": "Featured tournaments",
    "dashboard.recentActivity": "Recent activity",
    "dashboard.quickActions": "Quick actions",
    "dashboard.manageUsers": "Manage users",
    "dashboard.manageTournaments": "Manage tournaments",
    "dashboard.permissions": "Permissions",
    "dashboard.managePerms": "Manage permissions",
    "dashboard.thisWeek": "this week",
    "dashboard.ongoing": "ongoing",
    "dashboard.completed": "completed",
    "dashboard.needsAction": "Needs action",
    "dashboard.participants": "participants",
    "players.title": "Athletes",
    "players.subtitle": "Master list of athletes with profile and basic stats.",
    "players.search": "Search",
    "players.searchPlaceholder": "Search by name, username, email, phone or DUPR...",
    "players.searchBtn": "Search",
    "players.list": "List",
    "players.col.stt": "#",
    "players.col.athlete": "Athlete",
    "players.col.contact": "Contact",
    "players.col.profile": "Profile",
    "players.col.address": "Address",
    "players.col.rating": "Rating",
    "players.col.played": "Played",
    "players.col.stats": "Stats",
    "players.col.status": "Status",
    "players.empty": "No data",
    "players.totalSuffix": "athletes",
    "players.show": "Showing",
    "players.prev": "Prev",
    "players.next": "Next",
    "players.status.active": "Active",
    "players.status.inactive": "Inactive",
    "players.tournaments": "tournaments",
    "players.regs": "teams",
    "players.approved": "approved",
    "players.detail.title": "Athlete details",
    "players.detail.regs": "Registrations",
    "players.detail.matches": "Recent matches",
    "players.detail.noRegs": "No registrations yet",
    "players.filters.title": "Filters",
    "players.filters.status": "Status",
    "players.filters.statusAll": "All",
    "players.filters.statusActive": "Active",
    "players.filters.statusInactive": "Inactive",
    "players.filters.province": "Province",
    "players.filters.provinceAll": "All provinces",
    "players.filters.rating": "Rating",
    "players.filters.ratingMin": "Min",
    "players.filters.ratingMax": "Max",
    "players.filters.reset": "Reset",
    "players.filters.apply": "Apply",
    "players.filters.activeCount": "{n} active filters",
  },
};

const I18nContext = createContext({ lang: "vi", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "vi";
    return localStorage.getItem(STORAGE_KEY) || "vi";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((next) => setLangState(next === "en" ? "en" : "vi"), []);
  const t = useCallback((key) => DICT[lang]?.[key] || DICT.vi[key] || key, [lang]);

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
